/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react"
import BackButton from "../../../../components/Tablet/BackButton"
import { CSS_PROPERTY } from "../../cssProperties/tablet"
import GridButton from "../../../../components/Tablet/GridButton"
import { useHistory } from "react-router-dom"
import { TenkoKubunContext, TenkoDetailContext } from "../../context/context"
import ZyomuinInfo from "../../../../components/Tablet/ZyomuinInfo"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons"
import {
  selectSyukiObiPage,
  selectHiroSippeiSuiminBusokuPage,
  sonotaHokokuPage,
} from "../../../../constant/tablet/pages"
import { e点呼区分 } from "../../../../constant/enum/unko"

const SelectAlcoholCheck = () => {
  const history = useHistory()
  const { 点呼区分 } = useContext(TenkoKubunContext)
  const { 点呼明細, set点呼明細 } = useContext(TenkoDetailContext)

  const select日常点検 = (AL検知器使用フラグ: 0 | 1) => async () => {
    set点呼明細({
      ...点呼明細,
      AL検知器使用フラグ: AL検知器使用フラグ,
    })

    if (AL検知器使用フラグ === 0) {
      if (
        点呼区分?.区分コード !== e点呼区分.終業点呼 &&
        点呼区分?.区分コード !== e点呼区分.終業点呼2
      ) {
        history.push(selectHiroSippeiSuiminBusokuPage.Route.path)
      } else {
        history.push(sonotaHokokuPage.Route.path)
      }
    } else {
      history.push(selectSyukiObiPage.Route.path)
    }
  }

  return (
    <>
      <ZyomuinInfo />
      <table
        style={{ tableLayout: "fixed", height: CSS_PROPERTY.BODY_TABLE_HEIGHT }}
        className="w-100 mt-3">
        <tbody>
          <tr>
            <td colSpan={2}>アルコール測定は行いましたか？</td>
          </tr>
          <tr>
            <td>
              <GridButton onTouchStartEventHandler={select日常点検(1)}>
                <div
                  style={{
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                  }}>
                  <FontAwesomeIcon
                    style={{ marginRight: "2rem", color: "#0074be" }}
                    icon={faCheck}
                  />
                  <span>測定</span>
                  <span style={{ fontWeight: "bold" }}>した</span>
                </div>
              </GridButton>
            </td>
            <td>
              <GridButton onTouchStartEventHandler={select日常点検(0)}>
                <div
                  style={{
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                  }}>
                  <div
                    className="d-inline-block"
                    style={{ position: "relative" }}>
                    <FontAwesomeIcon
                      style={{
                        marginRight: "2rem",
                        color: CSS_PROPERTY.WARN_COLOR,
                      }}
                      icon={faTimes}
                    />
                  </div>
                  <span>測定</span>
                  <span style={{ fontWeight: "bold" }}>していない</span>
                </div>
              </GridButton>
            </td>
          </tr>
          <tr>
            <td
              className="align-bottom"
              style={{ height: CSS_PROPERTY.BODY_TABLE_BUTTON_ROW_HEIGHT }}>
              {/* 中間点呼でここに来た場合、登録後の関係上、前のページに戻るのは不都合があるためボタンを表示しない */}
              {[
                e点呼区分.中間点呼１,
                e点呼区分.中間点呼２,
                e点呼区分.中間点呼３,
              ].find((コード) => コード === 点呼区分?.区分コード) == null && (
                <BackButton />
              )}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default SelectAlcoholCheck
